// Shared product category list — used by the main Generator and Folder flows.
export const productCategories = [
  'Beauty & Skincare',
  'Fashion & Apparel',
  'Health & Wellness',
  'Home & Kitchen',
  'Electronics & Gadgets',
  'Food & Beverage',
  'Fitness & Sports',
  'Pet Products',
  'Baby & Kids',
  'Accessories',
  'Other',
];

export default productCategories;
